export const TeamMutations = {
  setTeams: (state, data) => { state.teams = data },
}
